import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { get } from "util/requests";
import moment from "moment";
import styles from "./data.module.css";
import { useSelector } from "react-redux";
import { corelab_api_url } from "config";

export default function Data(props) {
  const [spinning, setSpinning] = useState(false);
  const [jsonSpinning, setJsonSpinning] = useState(false);
  const [lockedSpinning, setLockedSpinning] = useState(false);
  const [imagingSpinning, setImagingSpinning] = useState(false);
  const [subjectImagingSpinning, setSubjectImagingSpinning] = useState(false);
  const [usersSpinning, setUsersSpinning] = useState(false);
  const [saeSpinning, setSaeSpinning] = useState(false);
  const [crSpinning, setCRSpinning] = useState(false);

  const user_data = useSelector((state) => state.user.userData);
  const study_id = useSelector((state) => state.study.active_study_id);
  const permissions = useSelector((state) => state.user.userData.permissions) || [];

  const study_name = user_data.studies.find((s) => s.id === study_id)?.name;
  const download_data = () => {
    setSpinning(true);
    get(`/export_data/${study_id}`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_subject_data_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.csv`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setSpinning(false);
    });
  };

  const download_crf_json_data = () => {
    setJsonSpinning(true);
    get(`/export_crf_json_data/${study_id}`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_crf_status_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.json`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setJsonSpinning(false);
    });
  };

  const download_sae_json_data = () => {
    setSaeSpinning(true);
    get(`/export_sae_json_data/${study_id}`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_sae_json_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.json`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setSaeSpinning(false);
    });
  };

  const download_randomization_data = () => {
    setLockedSpinning(true);
    get(`/export_locked_randomization_data/${study_id}`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_locked_randomization_data_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.json`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setLockedSpinning(false);
    });
  };

  const download_imaging_files = () => {
    setImagingSpinning(true);
    get(`${corelab_api_url}/export_imaging_files/${study_id}`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_imaging_file_data_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.csv`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setImagingSpinning(false);
    });
  };

  const download_subject_imaging_data = () => {
    setSubjectImagingSpinning(true);
    get(`${corelab_api_url}/export_subject_imaging_data/${study_id}`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_subject_imaging_data_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.csv`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setSubjectImagingSpinning(false);
    });
  };

  const download_users = () => {
    setUsersSpinning(true);
    get(`/export_user_data`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_user_export_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.csv`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setUsersSpinning(false);
    });
  };

  const download_consent_record_csv = () => {
    setCRSpinning(true);
    get(`/download_consent_record_csv/${study_id}`).then((ret) => {
      let { data, environment } = ret.data;
      const fileName = `${study_name.toLowerCase().replaceAll(" ", "_")}_consent_records_${environment}`;
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${fileName} - ${moment().format("YYYY-MM-DD HHmmss")}.csv`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setCRSpinning(false);
    });
  };

  const dataExports = () => (
    <div>
      <div>
        <h3>Data Exports</h3>
      </div>
      <div className={styles.buttons}>
        <div className={styles.button}>
          <LoadingButton
            variant="contained"
            loading={spinning}
            onClick={download_data}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            Subject EDC CSV
          </LoadingButton>
        </div>
        <div className={styles.button}>
          <LoadingButton
            variant="contained"
            loading={jsonSpinning}
            onClick={download_crf_json_data}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            Subject CRF JSON
          </LoadingButton>
        </div>
        <div className={styles.button}>
          <LoadingButton
            variant="contained"
            loading={saeSpinning}
            onClick={download_sae_json_data}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            Subject SAE JSON
          </LoadingButton>
        </div>
        <div className={styles.button}>
          <LoadingButton
            variant="contained"
            loading={crSpinning}
            onClick={download_consent_record_csv}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            Consent Records
          </LoadingButton>
        </div>
        {study_id === 1 ? (
          <div className={styles.button}>
            <LoadingButton
              variant="contained"
              loading={lockedSpinning}
              onClick={download_randomization_data}
              sx={{
                fontSize: 14,
                padding: "2px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              Locked Randomization JSON
            </LoadingButton>
          </div>
        ) : null}
      </div>
    </div>
  );

  const corelabExports = () => (
    <div>
      <div>
        <h3>Core Lab Exports</h3>
      </div>
      <div className={styles.buttons}>
        <div className={styles.button}>
          <LoadingButton
            variant="contained"
            loading={imagingSpinning}
            onClick={download_imaging_files}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            Imaging Files
          </LoadingButton>
        </div>
        <div className={styles.button}>
          <LoadingButton
            variant="contained"
            loading={subjectImagingSpinning}
            onClick={download_subject_imaging_data}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            Subject Imaging Data
          </LoadingButton>
        </div>
      </div>
    </div>
  );

  const adminExports = () => (
    <div>
      <div>
        <h3>Admin Exports</h3>
      </div>
      <div className={styles.buttons}>
        <div className={styles.button}>
          <LoadingButton
            variant="contained"
            loading={usersSpinning}
            onClick={download_users}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            All Users
          </LoadingButton>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      {permissions.includes("data_export") && dataExports()}
      {permissions.includes("corelab_data_export") && corelabExports()}
      {permissions.includes("admin_data_export") && adminExports()}
    </div>
  );
}
